import image1 from "../images/esports.svg"
import mobileImage from "../images/mobile.svg"
import image2 from "../images/discord.svg"
import image3 from "../images/code.svg"
import SasiImg from "../images/sasi.svg"
import SudhakarImg from "../images/sudhakar.svg"
import GeorginaImg from "../images/georgina.svg"
import JamesImg from "../images/james.svg"
import AmitImg from "../images/amit.svg"
import MaithiliImg from "../images/Maithili.svg"
import canidImg from "../images/canid-vaccine.svg"
import step_3 from "../images/step_3.png"
import iMacImg from "../images/iMac.svg"
import ScreelyImg from "../images/screely.svg"
import onboardImg from "../images/onboard.png"
import startupsImgFour from "../images/startups_4.png"
import archimydesPlatform from "../images/placeholder-timeline2.svg"

import RecruitImg from "../images/recruit.svg"
import ValueImg from "../images/value.svg"
import CodeReviewImg from "../images/code-review.svg"
import MonitizeImg from "../images/montize.svg"
import GuildMemberImg from "../images/guild-member.svg"

export const apprenticeHowItWorksData = [
  {
    title: "Top-tier start ups",
    text: "An intensive 3 month apprenticeship with curated startups",
    timelineTitle: "Learn with real world experience",
    tiimelineText:
      "Build products that help solve real world problems. Get your hands dirty by working alongside high-performance teams that are disrupting their respective industries",
    desktopImage: image1,
    mobileImage: mobileImage,
  },
  {
    title: "Mentorship",
    text: "Upskill through guidance from premier solution architects",
    timelineTitle: "Personalized coaching from the best in the industry",
    tiimelineText:
      "Your Mentor will guide you through code reviews, pair programming, and 1:1 sessions to help make you a top-notch developer",
    desktopImage: image2,
    desktopImage2: image3,
  },
  {
    title: "Job offer",
    text: "Full-time job opportunity at the end of the program",
    timelineTitle: "Get access to some of the best jobs in the industry",
    tiimelineText:
      "An opportunity to land a full-time job with the startup that you apprentice with, and other flexible options to monetize your skill through the Archimydes Code-as-a-service platform",
    desktopImage: step_3,
  },
]

export const commitmentData = [
  {
    text: "Core time committed for the assigned project",
    backgroundColor: "#FFF6D7",
    boxShadow: "#F4EAC8",
  },
  {
    text: "Weekly code review and pair programming sessions",
    backgroundColor: "#DCF7E8",
    boxShadow: "#BBE6CE",
  },
  {
    text: "Approach projects with zeal and seriousness",
    backgroundColor: "#E1F5FE",
    boxShadow: "#B7DEF0",
  },
  {
    text: "Effectively use the Archimydes Guild to interact and learn",
    backgroundColor: "#FFEBEE",
    boxShadow: "#F1C7CD",
  },
  {
    text: "Become future mentors yourself down the line",
    backgroundColor: "#EDE7F6",
    boxShadow: "#D5C4ED",
  },
]

export const askData = [
  {
    text:
      "Weekly pre-agreed time committed for the assigned Apprentices and Project",
    backgroundColor: "#FFF6D7",
    boxShadow: "#F4EAC8",
  },
  {
    text: "A genuine and active interest in the progress of the Apprentice",
    backgroundColor: "#DCF7E8",
    boxShadow: "#BBE6CE",
  },
  {
    text: "Participation in monthly or quarterly knowledge sharing sessions",
    backgroundColor: "#E1F5FE",
    boxShadow: "#B7DEF0",
  },
]

export const mentorData = [
  {
    name: "Sasi Kumar",
    location: "madurai",
    text:
      "Lead Engineer & Full Stack Developer at ThoughtWorks, with experience in eXtreme Programming (XP) practices & Agile methodologies.",
    image: SasiImg,
  },
  {
    name: "Georgina",
    location: "new york",
    text:
      "Full Stack Developer at MonetaGo. A seasoned coach who’s past experience includes organizations such as The Grace Hopper Program and the Flatiron School. ",
    image: GeorginaImg,
  },
  {
    name: "Sudhakar Rayavaram",
    location: "chennai",
    text:
      "Ex ThoughtWorker and an archetype problem solver with 18 years of experience in software design and development across the stack. ",
    image: SudhakarImg,
  },
]

export const socialEnterpriseData = [
  {
    title: "Projects",
    text:
      "The first step in our apprentice audition process is to identify appropriate projects for apprentices to work on",
    timelineTitle: "Identify potential projects",
    tiimelineText:
      "Our Solution Architect mentors help identify potential projects for Apprentices to work on",
    desktopImage: canidImg,
    mobileImage: mobileImage,
  },
  {
    title: "Onboard",
    text:
      "Select pre-screened Apprentices that you would like to work with as a social enterprise",
    timelineTitle: "On-board Candidates",
    tiimelineText:
      "Once apprentice candidates have been selected we help on-board them to your team from a legal, technical, and functional perspective so that they are ready to hit the ground running",
    desktopImage: onboardImg,
  },
  {
    title: "Apprenticeship",
    text:
      "Execute a 3-month apprenticeship with Archimydes mentors guiding the process",
    timelineTitle: "Complete your project",
    tiimelineText:
      "We assign tasks to the Apprentices leveraging the Archimydes platform and methodology. Archimydes mentors - seasoned developers with experience from top companies like ThoughtWorks, along with our delivery leads will guide the apprentices as they work through your project to completion",
    desktopImage: image3,
    desktopImage2: archimydesPlatform,
  },
]

export const socialEnterpriseDeveloperData = [
  {
    title: "Code Reviews",
    text:
      "Code will be reviewed by our Solution Architects who mentor your Apprentices",
    image: CodeReviewImg,
  },
  {
    title: "Recruit",
    text: "Recruit Apprentices for a more permanent role in your organization",
    image: RecruitImg,
  },
  {
    title: "Value",
    text: "Discounted rates of service for Social enterprises",
    image: ValueImg,
  },
]

export const developerData = [
  {
    name: "Sasi Kumar",
    location: "madurai",
    text:
      "Lead Engineer at ThoughtWorks, with experience in eXtreme Programming (XP) practices & Agile methodologies.",
    image: SasiImg,
    title: "Mentor",
  },
  {
    name: "Maithili D",
    location: "new york",
    text:
      "Maithili is a Full Stack Developer with a Masters in Computer Science. She has a keen interest in web development.",
    image: MaithiliImg,
    title: "Apprentice",
  },
  {
    name: "Sudhakar Rayavaram",
    location: "chennai",
    text:
      "Ex ThoughtWorker and an archetype problem solver with 18 years of experience.",
    image: SudhakarImg,
    title: "Mentor",
  },
]

export const apprenticeData = [
  {
    name: "James Midzi",
    location: "harare",
    text:
      "A self-taught Frontend Engineer who also happens to be a French Tutor.",
    image: JamesImg,
  },
  {
    name: "Maithili D",
    location: "new york",
    text:
      "Maithili is a Full Stack Developer with a Masters in Computer Science.",
    image: MaithiliImg,
  },
  {
    name: "Amit Kumar",
    location: "Ranchi",
    text:
      "Amit is a self-taught Full Stack Engineer with an appetite to learn.",
    image: AmitImg,
  },
]

export const mentorHowItWorksData = [
  {
    title: "Projects",
    text: "Pick your choice from curated start-ups and social enterprises",
    timelineTitle: "Work on high impact projects",
    tiimelineText:
      "We’ll map you with the right projects to Mentor on based on your availability and your Apprentice’s skill level",
    desktopImage: ScreelyImg,
    mobileImage: mobileImage,
  },
  {
    title: "Coaching",
    text: "Connect with your Apprentices via weekly coaching channels",
    timelineTitle: "Upskill & train aspiring developers",
    tiimelineText:
      "Mentor your apprentices through code reviews, pair programming, and 1:1 sessions to help make them a top-notch developer",
    desktopImage: image3,
    desktopImage2: iMacImg,
  },
]

export const mentorPointData = [
  {
    title: "Recruit",
    text: "Recruit Apprentices for a more permanent role in your organization",
    image: RecruitImg,
  },
  {
    title: "Monetise",
    text:
      "Monetise your time coaching high-potential developers working on impactful projects",
    image: MonitizeImg,
  },
  {
    title: "Guild Member",
    text:
      "Be a long-term member of the Guild and enjoy all of its associated benefits   ",
    image: GuildMemberImg,
  },
]

export const screeningProcessData = [
  {
    title: "Application",
    description:
      "Apprentices apply through our partner bootcamps or social media channels",
    boxColor: "linear-gradient(260.25deg, #F093FB -10.66%, #F5576C 113%)",
  },
  {
    title: "Basic Screening",
    description:
      "We screen each applicant for potential impact, skills and experience",
    boxColor: "linear-gradient(260.25deg, #667EEA -10.66%, #764BA2 113%)",
  },
  {
    title: "Coding Challenge",
    description: "Applicants are tested with our curated coding challenges",
    boxColor: "linear-gradient(260.25deg, #FF6A00 -10.66%, #EE0979 113%)",
  },
  {
    title: "Interviews",
    description:
      "1-1 interviews with our Solution Architects to help gauge applicants",
    boxColor: "linear-gradient(260.25deg, #F093FB -10.66%, #F5576C 113%)",
  },
  {
    title: "Developer Banding",
    description:
      "Apprentices are banded based on a comprehensive scoring criteria",
    boxColor: "linear-gradient(260.25deg, #667EEA -10.66%, #764BA2 113%)",
  },
  {
    title: "client screening",
    description: "Audition talent securely and respectfully before you hire",
    boxColor: "linear-gradient(260.25deg, #FF6A00 -10.66%, #EE0979 113%)",
  },
]

export const startuprHowItWorksData = [
  {
    title: "Projects",
    text:
      "The first step in our apprentice audition process is to identify appropriate projects for apprentices to work on",
    timelineTitle: "Identify potential projects",
    tiimelineText:
      "Our Solution Architect mentors help identify potential projects for Apprentices to work on",
    desktopImage: image1,
    mobileImage: mobileImage,
  },
  {
    title: "Onboard",
    text: "Select pre-screened Apprentices that you would like to audition",
    timelineTitle: "On-board Candidates",
    tiimelineText:
      "Once apprentice candidates have been selected we help on-board them to your team from a legal, technical, and functional perspective so that they are ready to hit the ground running",
    desktopImage: onboardImg,
  },
  {
    title: "Audition",
    text:
      "Execute a 3-month task-based audition of the candidates guided by both the Archimydes methodology and it's mentors",
    timelineTitle: "Execute the audition",
    tiimelineText:
      "Assign tasks to the Apprentices leveraging the Archimydes platform and methodology. Archimydes mentors - seasoned developers with experience from top companies like ThoughtWorks, will execute code review on each PR prior to merging into your project codebase",
    desktopImage: image3,
    desktopImage2: archimydesPlatform,
  },
  {
    title: "Hire",
    text:
      "Have the flexibility to bring on your apprentice(s) full-time once the audition period is complete",
    timelineTitle: "Hire your apprentice(s)",
    tiimelineText:
      "Once the audition is complete, have the option of hiring your apprentice(s) full-time. Execute a full-time employment contract or an employee lease agreement with the apprentice(s) based on their location.",
    desktopImage: startupsImgFour,
  },
]
